import { get, set, isEmpty, upperCase, omit, cloneDeep } from 'lodash'

export default (context, inject) => {
  inject('get', get)
  inject('set', set)
  inject('isEmpty', isEmpty)
  inject('upperCase', upperCase)
  inject('omit', omit)
  inject('cloneDeep', cloneDeep)
}
